import dayjs from 'dayjs'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Trans } from '@/components'
import { Timeline, TimelineItem } from '@/components/base/Timeline.tsx'
import { Deployment } from '@/models/deployment.ts'
import { DeploymentBill } from '@/models/deploymentBill.ts'
interface Props {
  _deployment: Deployment
  _deploymentBills: Map<string, DeploymentBill[]>
}

export default function DeploymentHistory({ _deployment, _deploymentBills }: Props) {
  const { t } = useTranslation()
  const [deploymentBills, setDeploymentBills] = useState<DeploymentBill[]>([])

  useEffect(() => {
    if (_deployment && _deploymentBills) {
      const bills = _deploymentBills.get(_deployment.resID) || []
      setDeploymentBills(bills)
    }
  }, [_deployment, _deploymentBills])

  const timelineItems = useMemo(() => {
    return deploymentBills
      .flatMap((bill) => {
        const items = [
          {
            id: `${bill.instResID}-create`,
            timestamp: bill.createTime.seconds,
            message: t('deploy.deployHistory.deploySuccess'),
          },
        ]

        if (bill.finishTime?.seconds && bill.finishTime.seconds !== 0) {
          items.push({
            id: `${bill.instResID}-finish`,
            timestamp: bill.finishTime.seconds,
            message: t('deploy.deployHistory.releaseSuccess'),
          })
        }

        return items
      })
      .sort((a, b) => a.timestamp - b.timestamp)
  }, [deploymentBills])

  return (
    <>
      {deploymentBills.length === 0 && (
        <div className="col-span-5 text-center text-secondary">
          <Trans i18nKey="deploy.deployHistory.noData">No deploy history available</Trans>
        </div>
      )}
      {deploymentBills.length > 0 && (
        <Timeline>
          {timelineItems.map((item) => (
            <TimelineItem key={item.id}>
              <div className="flex items-center space-x-4 py-3">
                <div className="text-secondary t-xs">
                  {dayjs.unix(item.timestamp).format('YYYY-MM-DD HH:mm')}
                </div>
                <div className="text-primary t-sb">{item.message}</div>
              </div>
            </TimelineItem>
          ))}
        </Timeline>
      )}
    </>
  )
}
